import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { lastValueFrom, Observable } from 'rxjs';
import { DEFAULT_LOCALE_CODE, TRANSLOCO_LANG_STORAGE_KEY } from 'transloco.config';

const preloadLang: (transloco: TranslocoService) => () => Promise<void> =
  (transloco: TranslocoService): (() => Promise<void>) =>
  async () => {
    transloco.setDefaultLang(DEFAULT_LOCALE_CODE);
    const activeLang = transloco.getActiveLang();
    localStorage.setItem(TRANSLOCO_LANG_STORAGE_KEY, activeLang);

    // Await the translation file to be loaded
    await lastValueFrom(transloco.load(activeLang));
  };

export const providePreloadLang = (): EnvironmentProviders[] => [
  provideAppInitializer((): void | Observable<unknown> | Promise<unknown> => {
    const initializerFn = preloadLang(inject(TranslocoService));
    return initializerFn();
  }),
];
